import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-avatar-upload',
  templateUrl: './avatar-upload.component.html',
  styleUrls: ['./avatar-upload.component.sass']
})
export class AvatarUploadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
